module.exports = __webpack_public_path__ + "components/flag/static/square/ss-b89748c139274b39506fefa0ccde4cd6.svg";